export default {
  goal: 'Accéder au parcours de conseil protection',
  title: 'Protection de vos proches',
  label: 'Protection de vos proches',
}
